import { render, staticRenderFns } from "./LogoutLink.vue?vue&type=template&id=3a53f4e2&scoped=true&"
import script from "./LogoutLink.vue?vue&type=script&lang=js&"
export * from "./LogoutLink.vue?vue&type=script&lang=js&"
import style0 from "./LogoutLink.vue?vue&type=style&index=0&id=3a53f4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53f4e2",
  null
  
)

export default component.exports